import { useQuery } from "react-query";
import SchemaService from "../api/services/SchemaService";

export const useGetBondBusinessFormSchema = (queryKey: string) => {
  const { data, isLoading, refetch, isError, error } = useQuery(queryKey, async () =>
    await SchemaService.getBondBusinessSchema()
  );

  return {
    bondBusinessSchema: data?.data?.schema,
    isBondBusinessSchemaLoading: isLoading,
    bondBusinessSchemaError: error,
    isBondBusinessSchemaError: isError,
    fetchBondBusinessSchema: refetch
  }
}